import { fromJS } from 'immutable';

import { ApiUrl4,UserToken,SenderId } from '../../../helper/HelperAuth'
import { GetWaProfileSetting } from '../../constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (senderid) => async (dispatch, getState) => {
    const Authorization = UserToken;
    const url = ApiUrl4 + 'config-waprofile-get';
    //debugger
    var sender = senderid
    // if(sender == null || sender == "" || sender == undefined){
    //     sender = SenderId
    // }
    
    const argument = {  
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
            'senderid':sender
        },
    };  

    const response = await doFetch(url,argument);
    var data = fromJS({});
    if(response.ok){
        data = fromJS(await response.json());
        data = data.get('query-result');
        data = data.get('data');
    }
    dispatch({ type: GetWaProfileSetting, data: fromJS(data) });
    return response
};